/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Delivery_ExplainerInputs */

const he_account_delivery_explainer = /** @type {(inputs: Account_Delivery_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בחרו לאן נשלחות ההתראות. כדי לערוך מה מפעיל התראה, עברו להתראות.`)
};

const en_account_delivery_explainer = /** @type {(inputs: Account_Delivery_ExplainerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose where alerts are delivered. For what triggers an alert, see Alerts.`)
};

/**
* | output |
* | --- |
* | "Choose where alerts are delivered. For what triggers an alert, see Alerts." |
*
* @param {Account_Delivery_ExplainerInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_delivery_explainer = /** @type {((inputs?: Account_Delivery_ExplainerInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Delivery_ExplainerInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_delivery_explainer(inputs)
	return en_account_delivery_explainer(inputs)
});